import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./navbar.css";

const Navbar = () => {
  const sections = [
    { id: "hero", label: "Home" },
    { id: "services", label: "Services" },
    { id: "features", label: "Solutions" }, 
    { id: "FAQ", label: "FAQ" },
    { id: "reviews", label: "Reviews" },
    { id: "team", label: "Team" },
    { id: "contact", label: "Contact" }
  ];

  const scrollToSection = (id: string) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const [activeSection, setActiveSection] = useState<string>("hero");

  useEffect(() => {
    const observerOptions = { root: null, threshold: 0.2 }; 

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    }, observerOptions);

    sections.forEach((section) => {
      const element = document.getElementById(section.id);
      if (element) observer.observe(element);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <nav className="navbar navbar-expand-lg navbar-landing fixed-top" id="navbar">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img src="assets/images/Oasys-dark.png" className="card-logo card-logo-dark" alt="logo dark" height="45" />
          <img src="assets/images/oasys_light.png" className="card-logo card-logo-light" alt="logo light" height="45" />
        </Link>

        <button className="navbar-toggler py-0 fs-20 text-body" type="button"
          data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span> 
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mx-auto mt-2 mt-lg-0" id="navbar-example">
            {sections.map((section) => (
              <li className="nav-item" key={section.id}>
                <a
                  className={`nav-link ${activeSection === section.id ? "active" : ""}`}
                  onClick={() => scrollToSection(section.id)}
                >
                  {section.label}
                </a>
              </li>
            ))}
          </ul>
          <div>
            <Link to="/login" className="btn btn-link fw-medium text-decoration-none text-dark">Sign in</Link>
            <Link to="/register" className="btn btn-primary">Sign Up</Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;